const upgradeText = gettext("Upgrade");
const downgradeText = gettext("Downgrade");
const subscribedText = gettext("Subscribed");

export const PurchaseOtherButton = ({status, btnStyle, noLink}) => {
    const manageUrl = catalogModule.getSource() === 'web' ? catalogModule.getUrl('all_products') : catalogModule.getUrl('manage_subscriptions');
    let textBtn;
    if(status && status === 'current'){
        textBtn = subscribedText;
    } else if(status && status === 'upgrade'){
        textBtn = upgradeText;
    } else if(status && status === 'downgrade'){
        textBtn = downgradeText;
    } else {
        textBtn = downgradeText;
    }
    if(noLink){
        return (
            <button className={btnStyle}>{textBtn}</button>
        )
    }
    return (
        <React.Fragment>
            <a href={manageUrl} target="_blank">
                <button className={btnStyle}>{textBtn}</button>
            </a>
        </React.Fragment>
    )
}
